import { useEffect, useState, Suspense, useContext } from "react";
import { AuthContext } from "./utils/contextapi/AuthProvider";
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { InnocodeProviderWrapper } from '@intsoft/innocode-core';

// CSS import 순서: 기본 스타일 먼저, innocode 스타일 가장 나중에 (CSS 우선순위)
import './App.css';
import '../src/resources/css/common.css';
import '@intsoft/innocode-payment/styles';
import '@intsoft/innocode-core/styles';
import axios from './utils/api/axios';
import LoginPage from './views/Login/Login';
import FindIdPage from './views/Login/FindIdPage';
import FindPasswordPage from './views/Login/FindPasswordPage';
import MfaPage from './views/Login/MfaPage';
import AccountPage from './views/Account/AccountHome';

import ManagementPage from './views/Management/Management';
import ServicePage from './views/Service/Service';
import Page from './views/Page/Page';
import AuthPage from './views/Auth/Auth';
import AuditPage from './views/Audit/Audit';
import PageAuthPage from './views/PageAuth/PageAuth';
import GroupPage from './views/Group/Group';
import ServiceUserPage from './views/ServiceUser/ServiceUser';
import ServiceUserApprovalPage from './views/ServiceUserApproval/ServiceUserApproval';

import DownloadPage from './views/Download/DownloadApp';
import Init from "./views/Login/Init";
import DashboardRouter from './views/Dashboard/DashboardRouter';
import AuthRedirect from './views/Account/AuthRedirect';
import SecurityPage from './views/Security/Security';
import TenantsPage from './views/Tenants/Tenants';
import TenantUserPage from './views/TenantUser/TenantUser';
import InvitePage from './views/Login/InvitePage';
import RegisterPage from './views/Login/RegisterPage';
import AuthEmailPage from './views/Login/mfa/AuthEmail';
import TenantsManagement from './views/TenantsManagement/TenantsManagement';
import SsoServiceGroupsPage from './views/SsoAdmin/SsoServiceGroups';
import TenantFederationsPage from './views/SsoAdmin/TenantFederations';

import PaymentPage from './views/ZentaPay/Payment/Payment';
import PaymentHistoryPage from './views/ZentaPay/PaymentHistory/PaymentHistory';
import PaymentHistoryDetailPage from './views/ZentaPay/PaymentHistory/PaymentHistoryDetail';
import SubscriptionPage from './views/ZentaPay/Subscription/Subscription';
import SubscriptionDetailPage from './views/ZentaPay/Subscription/SubscriptionDetail';
import RequestPay from './views/ZentaPay/RequestPay/RequestPay';

import Layout from './views/Layout';
import SsoPageWrapper from './views/SSO/SsoPageWrapper';
import TermsPage from './views/Login/TermsPage';


function App() {

    // const isMobile = useMediaQuery({
    //     query: "(max-width: 960px)"
    // });

    const [loading, setLoading] = useState(true);

    // 페이지 이동 시, JWT Token Refresh 를 위한 State(각 페이지에서 useEffect 로 호출)
    const [movePage, setMovePage] = useState("");

    // 사용자 권한 정보 (ContextProivider를 통해 전역으로 값 관리)
    const { role, isAuthenticated } = useContext(AuthContext);

    //새로고침 일 경우
    useEffect(() => {
        setLoading(false);
    }, []);

    // 페이지 전환 확인
    useEffect(() => {


    }, [movePage]);


    // // 권한이 필요한 경우 사용하는 HOC (High-Order Component)
    function RequireAuth({ children, requiredRoles = [], redirectTo = "/login" }) {
        const { isAuthenticated, isLoading } = useContext(AuthContext); // isLoading 가져오기
        //AuthProvider가 아직 상태를 확인 중이면, 아무것도 하지 않고 기다림
        if (isLoading) {
            return <div>Loading...</div>; // 또는 null
        }

        // 3. 인증되지 않았으면 로그인으로 이동
        if (!isAuthenticated) return <Navigate to={redirectTo} />;

        // 4. 권한이 하나라도 맞으면 통과
        if (
            requiredRoles.length === 0 ||
            (role && requiredRoles.some(r => role.includes(r)))
        ) {
            return children;
        }

        // 5. 권한 없으면 403 페이지 또는 로그인으로 이동
        return <Navigate to="/unauthorized" />;
    }

    useEffect(() => {
        const handleResize = () => {
            const body = document.body;
            body.setAttribute('data-theme-typography', 'KR');
            body.setAttribute('data-theme', 'light');

            if (window.innerWidth <= 375) {
                body.setAttribute('data-theme-grid', 'mobile');
            } else if (window.innerWidth <= 768) {
                body.setAttribute('data-theme-grid', 'tablet-vertical');
            } else {
                body.setAttribute('data-theme-grid', 'web');
            }
        };

        // 초기 실행
        handleResize();

        // resize 이벤트 리스너 등록
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <InnocodeProviderWrapper>
            <BrowserRouter>
                {loading ? "" :
                    <div>
                        <Suspense fallback={(<div>Loading...</div>)}>
                            <Routes>
                                <Route exact path="" element={<Navigate to={"/account/manage"} />} />
                                <Route exact path="/" element={<RequireAuth redirectTo="/account/manage" />} />
                                <Route exact path="/init/admin/:date" element={<Init />} />
                                <Route exact path="/download/app" element={<DownloadPage />} />
                                <Route exact path="/login" element={<LoginPage />} />
                                <Route exact path="/findid" element={<FindIdPage />} />
                                <Route exact path="/findpw" element={<FindPasswordPage />} />
                                <Route exact path="/mfa-auth" element={<MfaPage />} />
                                <Route exact path="/account" element={<AuthRedirect />} />
                                <Route exact path="/invite" element={<InvitePage />} />
                                <Route exact path="/register" element={<RegisterPage />} />
                                {/* <Route exact path="/testOTP" element={<OtpTest />} /> */}
                                <Route exact path="/auth/email/verify" element={<AuthEmailPage />} />
                                <Route exact path="/terms" element={<TermsPage />} />

                                <Route path="/unauthorized" element={<div>접근 권한이 없습니다.</div>} />

                                {/* 통합로그인 모달 페이지 호출 */}
                                <Route path="/sso/login" element={<SsoPageWrapper htmlFile="login.html" title="통합 로그인" />} />
                                <Route path="/sso/signup" element={<SsoPageWrapper htmlFile="signup.html" title="회원가입" />} />
                                <Route path="/sso/findId" element={<SsoPageWrapper htmlFile="findId.html" title="아이디 찾기" />} />
                                <Route path="/sso/findPw" element={<SsoPageWrapper htmlFile="findPw.html" title="비밀번호 찾기" />} />
                                <Route path="/sso/mfa" element={<SsoPageWrapper htmlFile="loginMFA.html" title="2단계 인증" />} />
                                <Route path="/sso/profile" element={<SsoPageWrapper htmlFile="profile.html" title="프로필 선택" />} />
                                <Route path="/sso/adminProfile" element={<SsoPageWrapper htmlFile="adminProfile.html" title="관리자 프로필 선택" />} />

                                {/* ZentaPay */}
                                <Route path="/zentaPay/requestPay" element={<RequestPay />} />


                                {/* --- ✅ NavBar가 있는 페이지들을 Layout 컴포넌트의 자식으로 그룹화 --- */}
                                <Route path="/" element={<Layout setMovePage={setMovePage} />}>

                                    {/* 계정관리 */}
                                    <Route exact path="account/manage" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <AccountPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="security" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <SecurityPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    {/* 테넌트 관리 */}
                                    <Route exact path="tenants" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <TenantsPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="tenantuser" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <TenantUserPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="service" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <ServicePage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    {/* 결제 및 구독 */}
                                    <Route exact path="payment" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <PaymentPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="payment_history" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <PaymentHistoryPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />
                                    <Route exact path="payment_history/detail/:paymentId" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <PaymentHistoryDetailPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="subscription" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <SubscriptionPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="subscription/detail/:subscriptionId" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <SubscriptionDetailPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />



                                    {/* IAM 관리자 */}
                                    <Route exact path="dashboard" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <DashboardRouter setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="tenantsMagement" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN"]}>
                                            <TenantsManagement setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="usermgmt" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN"]} >
                                            <ManagementPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="audit" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN"]}>
                                            <AuditPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />


                                    {/* 서비스 관리 */}
                                    <Route exact path="sso-service-groups" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN"]}>
                                            <SsoServiceGroupsPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="sso-federations" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN"]}>
                                            <TenantFederationsPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="service/dashboard" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <DashboardRouter setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="service/page" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <Page setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="service/auth" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <AuthPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="service/pageauth" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <PageAuthPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="service/group" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <GroupPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="service/serviceuser" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <ServiceUserPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />

                                    <Route exact path="service/serviceuser-approval" element={
                                        <RequireAuth requiredRoles={["SYS_ADMIN", "SERVICE_ADMIN", "USER"]}>
                                            <ServiceUserApprovalPage setMovePage={setMovePage} />
                                        </RequireAuth>
                                    } />
                                </Route>




                                <Route path="*" element={<Navigate to="/login" />} />
                            </Routes>
                        </Suspense>
                    </div>
                }
            </BrowserRouter>
        </InnocodeProviderWrapper>
    )
}

export default App;
